<script>
  import DynamicH2 from "../common/DynamicH2.svelte";
</script>

<style>
  input {
    border-bottom: 2px dotted rgba(255, 255, 255, 0.3);
    margin-bottom: 2rem;
  }

  input:focus {
    outline: none;
    border-bottom-color: rgb(232, 29, 83);
  }

  select {
    background: none;
    color: inherit;
    font-family: inherit;
    font-size: inherit;
  }
</style>

<div>
  <DynamicH2 inputText={'To get started, enter your name, age and gender.'} />

  <div class="flex-col">
    <label for="name">Name</label>
    <input type="text" name="name" class="clear-element" />

    <label for="age">Age</label>
    <input type="number" name="age" class="clear-element" min="18" max="100" />

    <label for="gender">Gender</label>
    <select name="gender">
      <option value="M">Male</option>
      <option value="F">Female</option>
      <option value="O">Other</option>
    </select>
  </div>
</div>
